export default {
  orderStatusArray: [
    {
      status: 1,
      statusString: '待配對'
    },
    {
      status: 2,
      statusString: '已配對'
    },
    {
      status: 3,
      statusString: '已確認環境表'
    },
    {
      status: 4,
      statusString: '清潔中'
    },
    {
      status: 5,
      statusString: '暫停清潔'
    },
    {
      status: 6,
      statusString: '待確認金額'
    },
    {
      status: 7,
      statusString: '完成'
    },
    {
      status: 8,
      statusString: '預計取消'
    },
    {
      status: 9,
      statusString: '已取消'
    },
    {
      status: 10,
      statusString: '後台取消'
    },
    {
      status: 11,
      statusString: '待確認收取款項'
    }
  ],
  defaultErrorMsg: '發生未預期的錯誤，請稍後在操作或與客服聯絡，謝謝',
  convertErrorMsg (res) {
    var errorData
    var errorMsg = '發生未預期的錯誤，請稍後在操作或與客服聯絡，謝謝'
    if (res) {
      if (res.response) {
        errorData = res.response.data
      }
      if (errorData && errorData.data) {
        errorMsg = errorData.data
      }
    }
    return errorMsg
  },
  getDefaultStaffCountry () {
    return [
      {
        id: 9,
        name: '台中市',
        cities: [
          {
            id: 17,
            label: '中區'
          },
          {
            id: 18,
            label: '東區'
          },
          {
            id: 21,
            label: '西區'
          },
          {
            id: 22,
            label: '南區'
          },
          {
            id: 23,
            label: '北區'
          },
          {
            id: 24,
            label: '西屯區'
          },
          {
            id: 25,
            label: '南屯區'
          },
          {
            id: 26,
            label: '北屯區'
          },
          {
            id: 27,
            label: '豐原區'
          },
          {
            id: 28,
            label: '大里區'
          },
          {
            id: 29,
            label: '太平區'
          },
          {
            id: 30,
            label: '清水區'
          },
          {
            id: 31,
            label: '沙鹿區'
          },
          {
            id: 32,
            label: '大甲區'
          },
          {
            id: 33,
            label: '東勢區'
          },
          {
            id: 34,
            label: '梧棲區'
          },
          {
            id: 35,
            label: '烏日區'
          },
          {
            id: 36,
            label: '神岡區'
          },
          {
            id: 37,
            label: '大肚區'
          },
          {
            id: 38,
            label: '大雅區'
          },
          {
            id: 39,
            label: '后里區'
          },
          {
            id: 40,
            label: '霧峰區'
          },
          {
            id: 41,
            label: '潭子區'
          },
          {
            id: 42,
            label: '龍井區'
          },
          {
            id: 43,
            label: '外埔區'
          },
          {
            id: 44,
            label: '和平區'
          },
          {
            id: 45,
            label: '石岡區'
          },
          {
            id: 46,
            label: '大安區'
          },
          {
            id: 47,
            label: '新社區'
          }
        ]
      }
    ]
  },
  arrangeContactTimeArray (array, enCode) {
    var finalArray = []
    if (array.length > 0) {
      if (enCode) {
        array.forEach((timeObj) => {
          var strArr = []
          if (timeObj) {
            if (timeObj.start !== null && timeObj.start && timeObj.end !== null && timeObj.end) {
              strArr.push(String(timeObj.start))
              strArr.push(String(timeObj.end))
            }
            if (strArr.length > 0) {
              finalArray.push(strArr.join('-'))
            }
          }
        })
      } else {
        array.forEach((timeStr) => {
          var strArr = []
          var timeObj = {
            start: null,
            end: null
          }
          if (timeStr && timeStr.includes('-')) {
            strArr = timeStr.split('-')
            timeObj.start = strArr[0]
            timeObj.end = strArr[1]
          }
          if (timeObj.start !== null && timeObj.end !== null) {
            finalArray.push(timeObj)
          }
        })
      }
    }
    return finalArray
  },
  arrangeOrderData (data) {
    var currentDate = this.getDateFormYYYYMMDD()
    var contactDsTime = []
    var cityArray = []
    var dsLocation
    if (data) {
      if (data.day !== undefined) {
        switch (data.day) {
          case 0:
            data.diplayWeekDay = '日'
            break
          case 1:
            data.diplayWeekDay = '一'
            break
          case 2:
            data.diplayWeekDay = '二'
            break
          case 3:
            data.diplayWeekDay = '三'
            break
          case 4:
            data.diplayWeekDay = '四'
            break
          case 5:
            data.diplayWeekDay = '五'
            break
          case 6:
            data.diplayWeekDay = '六'
            break
        }
      }
      if (data.roc_date === currentDate) {
        data.today = true
      } else {
        data.today = false
      }
      if (data.contact_times && Array.isArray(data.contact_times) && data.contact_times.length > 0) {
        data.contact_times.forEach((item) => {
          var itemArr = []
          var newStr = ''
          if (item) {
            itemArr = item.split('-')
            newStr = itemArr.join('點至')
            newStr += '點'
            contactDsTime.push(newStr)
          }
        })
      }
      if (contactDsTime.length > 0) {
        data.contactDsTime = contactDsTime
      }
      data = this.compareStaffMatchInfo(data)
      if (data.country) {
        cityArray.push(data.country)
      }
      if (data.city) {
        cityArray.push(data.city)
      }
      data.city_country = cityArray.join(',')
      if (data.include_check_staff !== undefined && data.include_check_staff !== null) {
        if (!data.include_check_staff) {
          dsLocation = data.location.replace(/[0-9]/g, 'O')
        } else {
          dsLocation = data.location
        }
      } else {
        dsLocation = data.location
      }
      data.dsLocation = dsLocation
      data = this.getStatusInfo(data)
    }
    return data
  },
  arrangeAccountData (data) {
    var cityArray = []
    if (data) {
      if (data.order_names) {
        data.names = data.order_names.join(', ')
      }
      if (data.country) {
        cityArray.push(data.country)
        cityArray.push(data.city)
        data.city_country = cityArray.join(',')
      }
    }
    return data
  },
  getStatusInfo (data) {
    switch (data.status_code) {
      case 1:
        // 待配對
        data.statusClass = 'order-status-warn'
        break
      case 2:
        // 已配對
        data.statusClass = 'order-status-gray'
        break
      case 3:
        // 已確認環境表
        data.statusClass = 'order-status-work'
        break
      case 4:
        // 清潔中
        data.statusClass = 'order-status-work'
        break
      case 5:
        // 暫停清潔
        data.statusClass = 'order-status-work'
        break
      case 6:
        // 待確認金額
        data.statusClass = 'order-status-work'
        break
      case 7:
        // 完成
        data.statusClass = 'order-status-sucess'
        data.cost_check = 1
        break
      case 8:
        // 預計取消
        data.statusClass = 'order-status-warn'
        break
      case 9:
        // 已取消
        data.statusClass = 'order-status-warn'
        break
      case 10:
        // 後台取消
        data.statusClass = 'order-status-warn'
        break
      case 11:
        // 待確認收取款項
        data.statusClass = 'order-status-warn'
        break
    }
    return data
  },
  compareStaffMatchInfo (data) {
    var staffArray = []
    if (data.staffs && Array.isArray(data.staffs)) {
      data.staffs.forEach((staff, index) => {
        if (staff) {
          if (staff.main) {
            staff.displayN = '[主] ' + staff.name
          } else {
            staff.displayN = staff.name
          }
          staffArray.push(staff)
        }
        if (index === data.staffs.length - 1) {
          data.staffs = staffArray
        }
      })
    }
    return data
  },
  turnToBoolean (val) {
    if (typeof val !== 'boolean') {
      switch (typeof val) {
        case 'number':
          if (val) {
            val = true
          } else {
            val = false
          }
          break
        case 'string':
          var parseVal = JSON.parse(val)
          if (parseVal) {
            val = true
          } else {
            val = false
          }
          break
        default:
          val = false
          break
      }
    }
    return val
  },
  turnToNumber (val) {
    var intVal
    if (typeof val !== 'number') {
      intVal = parseInt(val)
      if (!isNaN(intVal)) {
        val = intVal
      }
    }
    return val
  },
  convertOrderType (val, backVal) {
    var final = backVal ? 1 : '無'
    if (val) {
      if (!backVal) {
        switch (val) {
          case '1':
          case 1:
            final = '無'
            break
          case '2':
          case 2:
            final = '免費體驗'
            break
          case '3':
          case 3:
            final = '首小時優惠'
            break
        }
      } else {
        switch (val) {
          case '無':
            final = 1
            break
          case '免費體驗':
            final = 2
            break
          case '首小時優惠':
            final = 3
            break
        }
      }
    }
    return final
  },
  convertOrderUserType (val, backVal) {
    var final = backVal ? 1 : '一般'
    if (val) {
      if (!backVal) {
        switch (val) {
          case '1':
          case 1:
            final = '一般'
            break
          case '2':
          case 2:
            final = '貴賓'
            break
          case '3':
          case 3:
            final = 'VIP'
            break
        }
      } else {
        switch (val) {
          case '一般':
            final = 1
            break
          case '貴賓':
            final = 2
            break
          case 'VIP':
            final = 3
            break
        }
      }
    }
    return final
  },
  convertOrderpPrice (val) {
    var price = 9
    if (val) {
      switch (val) {
        case '1':
        case 1:
        case '一般':
          price = 9
          break
        case '2':
        case 2:
        case '貴賓':
          price = 8
          break
        case '3':
        case 3:
        case 'VIP':
          price = 7
          break
      }
    }
    return price
  },
  checkSingleNumToStr (val) {
    var final = '0'
    var str = ''
    if (val) {
      str = String(val)
      switch (str) {
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
          final += str
          break
        default:
          final = str
          break
      }
    }
    return final
  },
  getDateFormYYYYMMDD (date) {
    const dateObj = (date) ? new Date(date) : new Date()
    var m = '' + (dateObj.getMonth() + 1)
    var d = '' + dateObj.getDate()
    var y = dateObj.getFullYear() - 1911
    var dateArray = []
    if (m.length < 2) {
      m = '0' + m
    }
    if (d.length < 2) {
      d = '0' + d
    }
    dateArray.push(y)
    dateArray.push(m)
    dateArray.push(d)

    return dateArray.join('-')
  },
  getDateTimeValue (date, args) {
    const dateObj = (date) ? new Date(date) : new Date()
    const type = args ? args.type : 'date'
    var m
    var y
    var d
    var h
    var finalArray = []
    var final
    if (type === 'date') {
      m = (dateObj.getMonth() + 1)
      d = dateObj.getDate()
      y = args.ce ? dateObj.getFullYear() : dateObj.getFullYear() - 1911
      finalArray.push(y)
      finalArray.push(m)
      finalArray.push(d)
      final = finalArray.join('-')
    } else {
      h = (dateObj.getHours() + 1)
      m = dateObj.getMinutes()
      if (m < 10) {
        m = '0' + m
      }
      finalArray.push(h)
      finalArray.push(m)
      final = finalArray.join(':')
    }
    return final
  },
  getDateString (date) {
    const dateObj = (date) ? new Date(date) : new Date()
    var m
    var y
    var d
    var finalArray = []

    var final
    y = dateObj.getFullYear()
    m = (dateObj.getMonth() + 1)
    d = dateObj.getDate()
    if (m < 10) {
      m = '0' + m
    }
    if (d < 10) {
      d = '0' + d
    }

    finalArray.push(y)
    finalArray.push(m)
    finalArray.push(d)
    final = finalArray.join('-')
    return final
  },
  getTimeString (datetimeString) {
    const dateObj = (datetimeString) ? new Date(datetimeString) : new Date()
    var h = dateObj.getHours()
    var m = dateObj.getMinutes()
    if (h < 10) {
      h = '0' + h
    }
    if (m < 10) {
      m = '0' + m
    }

    return `${h}:${m}`
  }

}
